import { SUBTYPE_OPTS, time, getSuper, bindPrototype, assignPrivateSymbol, setSymbols, getSymbols, iu, initAbstract, construct, $combine, subtype, implementEngineer, $skip, makeClassSymbol } from '@type.engineering/type-engineer'
import './typedefs'
import '../../../types'
import { BuildingBlock, Concealed, proxifyState, setupClassSeersDelayed, control, getDataIds, delegateState } from '@mauriceguest/guest'

const gid=89137587

/**
 * @abstract
 * @extends {ru.hulkmoto.BookingColumnController}
 */
class _AbstractBookingColumnController {
 constructor() {
  construct(this)
 }
 /** @nocollapse */
 static control(el, opts) {
  const AllSymbols = { ...BookingColumnControllerSymbols, ...UserLoadererSymbols, ...DateRangerSymbols, ...TariffLoadererSymbols }
  /** @suppress {checkTypes} */
  const res = control(this, el, opts, AllSymbols)
  return /** @type {!ru.hulkmoto.BookingColumnController} */ (res)
 }
}
/**
 * The controller for the form.
 * @extends {ru.hulkmoto.BookingColumnController} ‎
 * @implements {ru.hulkmoto.IBookingColumnController} ‎
 */
export class AbstractBookingColumnController extends _AbstractBookingColumnController {

}
initAbstract(_AbstractBookingColumnController, 'IBookingColumnController', /** @this {AbstractBookingColumnController} */ function () {
 const { _bookingState, _bookingLoader } = getBookingColumnControllerSymbols(this)
 setBookingColumnControllerSymbols(this, {
  _bookingState: iu(_bookingState, null),
  _bookingLoader: iu(_bookingLoader, null),
 })
 const { superStateful: { setState, initialState } } = this
 const state = {
  selectedDay: null,
  discount: 0,
  bike: null,
  selectedYear: null,
  selectedMonth: null,
  monthlyAvailability: [],
  selectedHours: null,
  booking_id: '',
  showingSignupForm: false,
  showingLoginForm: false,
  uiState: 'signup-request',
  ...initialState,
 }
 proxifyState(state)
 setState(state)
})
/** @constructor @extends {_AbstractBookingColumnController} @suppress {checkTypes} */ function __AbstractBookingColumnController() {}
__AbstractBookingColumnController.prototype = /** @type {!_AbstractBookingColumnController} */ ({
 get bookingState() {
  return this[BookingColumnControllerSymbols._bookingState]
 },
 get bookingLoader() {
  return this[BookingColumnControllerSymbols._bookingLoader]
 },
 get isOnService() {
  return false
 },
 get asIBookingColumnController() {
  return /** @type {!ru.hulkmoto.BoundIBookingColumnController} */ (this)
 },
 get superIBookingColumnController() {
  return /** @type {!ru.hulkmoto.BoundIBookingColumnController} */ (bindPrototype(_AbstractBookingColumnController, this))
 },
 get superBookingColumnController() {
  return /** @type {!ru.hulkmoto.BoundBookingColumnController} */ (bindPrototype(_AbstractBookingColumnController, this))
 },
})
export const BookingColumnControllerSymbols = {
 _bookingState: makeClassSymbol(AbstractBookingColumnController, '_bookingState'),
 _bookingLoader: makeClassSymbol(AbstractBookingColumnController, '_bookingLoader'),
}

/** @type {ru.hulkmoto.getBookingColumnControllerSymbols} */
export const getBookingColumnControllerSymbols = (instance) => {
 return /** @type {!ru.hulkmoto.IBookingColumnControllerSymbolsOut} */ (getSymbols(instance, BookingColumnControllerSymbols))
}
/** @type {ru.hulkmoto.setBookingColumnControllerSymbols} */
export const setBookingColumnControllerSymbols = (instance, symbols) => {
 setSymbols(instance, symbols, BookingColumnControllerSymbols)
}

/** @constructor @extends {ru.hulkmoto.BookingColumnController} @suppress {checkTypes} */ function BookingColumnControllerChildren() {}
BookingColumnControllerChildren.prototype = /** @type {!ru.hulkmoto.BookingColumnController} */ ({
 /** @return {void} */
 __$constructor() {
  const children = getDataIds(this)
  setBookingColumnControllerChildrenSymbols(this, {
   _ColumnHolder: /** @type {HTMLDivElement} */ (children['ColumnHolder']),
   _Start: /** @type {HTMLParagraphElement} */ (children['Start']),
   _StartDate: /** @type {HTMLSpanElement} */ (children['StartDate']),
   _StartTime: /** @type {HTMLSpanElement} */ (children['StartTime']),
   _End: /** @type {HTMLParagraphElement} */ (children['End']),
   _EndDate: /** @type {HTMLSpanElement} */ (children['EndDate']),
   _EndTime: /** @type {HTMLSpanElement} */ (children['EndTime']),
   _TariffLoading: /** @type {HTMLDivElement} */ (children['TariffLoading']),
   _TariffOuter: /** @type {HTMLSpanElement} */ (children['TariffOuter']),
   _Tariff: /** @type {HTMLSpanElement} */ (children['Tariff']),
   _DiscountRow: /** @type {HTMLTableRowElement} */ (children['DiscountRow']),
   _TotalPrice: /** @type {HTMLSpanElement} */ (children['TotalPrice']),
   _UnavailableFeedback: /** @type {HTMLDivElement} */ (children['UnavailableFeedback']),
   _TariffLoaderFeedback: /** @type {HTMLDivElement} */ (children['TariffLoaderFeedback']),
   _TariffLoaderError: /** @type {HTMLElement} */ (children['TariffLoaderError']),
   _SignupFormContainer: /** @type {HTMLDivElement} */ (children['SignupFormContainer']),
   _SignupForm: /** @type {ru.hulkmoto.SignupFormController} */ (children['SignupForm']),
   _LoginFormContainer: /** @type {HTMLDivElement} */ (children['LoginFormContainer']),
   _LoginForm: /** @type {ru.hulkmoto.LoginFormController} */ (children['LoginForm']),
   _RegisterButton: /** @type {HTMLAnchorElement} */ (children['RegisterButton']),
   _WhatsAppButton: /** @type {HTMLAnchorElement} */ (children['WhatsAppButton']),
   _PayButton: /** @type {HTMLButtonElement} */ (children['PayButton']),
   _BookingLoaderError: /** @type {HTMLDivElement} */ (children['BookingLoaderError']),
   _BookingSuccess: /** @type {HTMLDivElement} */ (children['BookingSuccess']),
   _BookingId: /** @type {HTMLSpanElement} */ (children['BookingId']),
   _BookingLoader: /** @type {HTMLDivElement} */ (children['BookingLoader']),
   _HaveAccount: /** @type {HTMLDivElement} */ (children['HaveAccount']),
   _AuthoriseLink: /** @type {HTMLAnchorElement} */ (children['AuthoriseLink']),
   _NoAccount: /** @type {HTMLDivElement} */ (children['NoAccount']),
   _RegisterLink: /** @type {HTMLAnchorElement} */ (children['RegisterLink']),
   _AuthInfo: /** @type {HTMLDivElement} */ (children['AuthInfo']),
   _UserName: /** @type {HTMLSpanElement} */ (children['UserName']),
   _SignOutButton: /** @type {HTMLAnchorElement} */ (children['SignOutButton']),
   _AuthWarning: /** @type {HTMLDivElement} */ (children['AuthWarning']),
   _AcceptPrivacyText: /** @type {HTMLParagraphElement} */ (children['AcceptPrivacyText']),
  })
  setTimeout(() => {
   const ColumnHolder = /** @type {guest.maurice.ui.Concealed} */ (/** @type {HTMLElement} */ (this.ColumnHolder))
   if (ColumnHolder) {
    const classesInfo = /** @type {!ru.hulkmoto.IBookingColumnController.Classes} */ ({
     /** @this {ru.hulkmoto.IBookingColumnController} */
     get BottomGreenGradient() {
      return this.hasLoaded
     },
     /** @this {ru.hulkmoto.IBookingColumnController} */
     get BottomYellowGradient() {
      return this.isOnService
     },
     /** @this {ru.hulkmoto.IBookingColumnController} */
     get BottomRedGradient() {
      return this.tariffLoader.state.error
     },
     /** @this {ru.hulkmoto.IBookingColumnController} */
     get RemoveBackground() {
      return this.hasLoaded || this.tariffLoader.state.error
     },
    })
    setupClassSeersDelayed(ColumnHolder, classesInfo, this)
   }
   const StartTime = /** @type {guest.maurice.ui.Concealed} */ (/** @type {HTMLElement} */ (this.StartTime))
   if (StartTime) {
    const startTime = Concealed.control(StartTime, { shadow: true })
    startTime.setDerivedState({
     /** @this {ru.hulkmoto.IBookingColumnController} */
     get concealed() {
      return !this.dateRange.state.startDate
     } }, this)
   }
   const EndTime = /** @type {guest.maurice.ui.Concealed} */ (/** @type {HTMLElement} */ (this.EndTime))
   if (EndTime) {
    const endTime = Concealed.control(EndTime, { shadow: true })
    endTime.setDerivedState({
     /** @this {ru.hulkmoto.IBookingColumnController} */
     get concealed() {
      return !this.dateRange.state.endDate
     } }, this)
   }
   const TariffLoading = /** @type {guest.maurice.ui.Concealed} */ (/** @type {HTMLElement} */ (this.TariffLoading))
   if (TariffLoading) {
    const tariffLoading = Concealed.control(TariffLoading, { shadow: true })
    tariffLoading.setDerivedState({
     /** @this {ru.hulkmoto.IBookingColumnController} */
     get concealed() {
      return !this.tariffLoader.state.loading
     } }, this)
   }
   const TariffOuter = /** @type {guest.maurice.ui.Concealed} */ (/** @type {HTMLElement} */ (this.TariffOuter))
   if (TariffOuter) {
    const tariffOuter = Concealed.control(TariffOuter, { shadow: true })
    tariffOuter.setDerivedState({
     /** @this {ru.hulkmoto.IBookingColumnController} */
     get concealed() {
      return this.tariffLoader.state.loading
     } }, this)
   }
   const DiscountRow = /** @type {guest.maurice.ui.Concealed} */ (/** @type {HTMLElement} */ (this.DiscountRow))
   if (DiscountRow) {
    const discountRow = Concealed.control(DiscountRow, { shadow: true })
    discountRow.setDerivedState({
     /** @this {ru.hulkmoto.IBookingColumnController} */
     get concealed() {
      return !this.state.discount
     } }, this)
   }
   const UnavailableFeedback = /** @type {guest.maurice.ui.Concealed} */ (/** @type {HTMLElement} */ (this.UnavailableFeedback))
   if (UnavailableFeedback) {
    const unavailableFeedback = Concealed.control(UnavailableFeedback, { shadow: true })
    unavailableFeedback.setDerivedState({
     /** @this {ru.hulkmoto.IBookingColumnController} */
     get concealed() {
      return !this.isOnService
     } }, this)
   }
   const TariffLoaderFeedback = /** @type {guest.maurice.ui.Concealed} */ (/** @type {HTMLElement} */ (this.TariffLoaderFeedback))
   if (TariffLoaderFeedback) {
    const tariffLoaderFeedback = Concealed.control(TariffLoaderFeedback, { shadow: true })
    tariffLoaderFeedback.setDerivedState({
     /** @this {ru.hulkmoto.IBookingColumnController} */
     get concealed() {
      return !this.tariffLoader.state.error
     } }, this)
   }
   const SignupFormContainer = /** @type {guest.maurice.ui.Concealed} */ (/** @type {HTMLElement} */ (this.SignupFormContainer))
   if (SignupFormContainer) {
    const signupFormContainer = Concealed.control(SignupFormContainer, { shadow: true })
    signupFormContainer.setDerivedState({
     /** @this {ru.hulkmoto.IBookingColumnController} */
     get concealed() {
      return this.state.uiState != 'signup'
     } }, this)
   }
   const LoginFormContainer = /** @type {guest.maurice.ui.Concealed} */ (/** @type {HTMLElement} */ (this.LoginFormContainer))
   if (LoginFormContainer) {
    const loginFormContainer = Concealed.control(LoginFormContainer, { shadow: true })
    loginFormContainer.setDerivedState({
     /** @this {ru.hulkmoto.IBookingColumnController} */
     get concealed() {
      return this.state.uiState != 'login'
     } }, this)
   }
   const RegisterButton = /** @type {guest.maurice.ui.Concealed} */ (/** @type {HTMLElement} */ (this.RegisterButton))
   if (RegisterButton) {
    RegisterButton.addEventListener('click', (ev) => {
     ev.preventDefault()
     this.switchUiState('signup')
     window['ym'](gid,'reachGoal','StartSignup')
     return false
    })
    const registerButton = Concealed.control(RegisterButton, { shadow: true })
    registerButton.setDerivedState({
     /** @this {ru.hulkmoto.IBookingColumnController} */
     get concealed() {
      return this.state.uiState != 'signup-request'
     } }, this)
   }

   const WhatsAppButton = /** @type {guest.maurice.ui.Concealed} */ (/** @type {HTMLElement} */ (this.WhatsAppButton))
   if (WhatsAppButton) {
    WhatsAppButton.addEventListener('click', (ev) => {
     ev.preventDefault()
     // const t=this
     let h=document.querySelector('h1').innerText
     h=h.replace(/(\d+$)/,' $1')
     const{dateRange}=this
     const{startMonth,startDate,startHours,endMonth,endDate,endHours}=dateRange
     const s=new Date()
     s.setMinutes(0)
     s.setSeconds(0)
     if(startHours!==null) s.setHours(startHours)
     if(startDate!==null) s.setDate(startDate)
     if(startMonth!==null) s.setMonth(startMonth)
     const e=new Date()
     e.setMinutes(0)
     e.setSeconds(0)
     if(endHours!==null) e.setHours(endHours)
     if(endDate!==null) e.setDate(endDate)
     if(endMonth!==null) e.setMonth(endMonth)
     const start=s.toLocaleString('ru')
     const end=e.toLocaleString('ru')
     let tariff=''
     switch(this.bookingState.currentTariff) {
     case'day':{
      tariff='дневной'
      break
     }
     case'twentyFourHours':{
      tariff='суточный'
      break
     }
     case'night':{
      tariff='ночной'
      break
     }
     case'fiveHours':{
      tariff='почасовой'
      break
     }
     }
     const text='Интересует бронь '+h+` с ${start} по ${end} (${tariff} тариф).`
     const phone=`+79856369696`
     popupCenter({url:`https:/`+`/wa.me/${phone}?text=${text}`,title:'whatsapp',w:500,h:375})
     if(window['ym']){
      window['ym'](gid,'reachGoal','whats App')
      // window['ym'](gid,'reachGoal','whatsApp')
     }
     // const w=window.open(,'whatsapp',"height=500,width=500")

     // open whatsapp window
     // this.switchUiState('signup')
     return false
    })
    const whatsAppButton = Concealed.control(WhatsAppButton, { shadow: true })
    whatsAppButton.setDerivedState({
     /** @this {ru.hulkmoto.IBookingColumnController} */
     get concealed() {
      return this.state.uiState != 'signup-request'
     } }, this)
   }

   const PayButton = /** @type {guest.maurice.ui.Concealed} */ (/** @type {HTMLElement} */ (this.PayButton))
   if (PayButton) {
    PayButton.addEventListener('click', (ev) => {
     ev.preventDefault()
     window['ym'](89137587,'reachGoal','FormSell')
     this.pay()
     return false
    })
    const payButton = Concealed.control(PayButton, { shadow: true })
    payButton.setDerivedState({
     /** @this {ru.hulkmoto.IBookingColumnController} */
     get concealed() {
      return this.bookingState.booking_id || this.state.uiState != 'user'
     } }, this)
   }
   const BookingLoaderError = /** @type {guest.maurice.ui.Concealed} */ (/** @type {HTMLElement} */ (this.BookingLoaderError))
   if (BookingLoaderError) {
    const bookingLoaderError = Concealed.control(BookingLoaderError, { shadow: true })
    bookingLoaderError.setDerivedState({
     /** @this {ru.hulkmoto.IBookingColumnController} */
     get concealed() {
      return !this.bookingLoader.state.error
     } }, this)
   }
   const BookingSuccess = /** @type {guest.maurice.ui.Concealed} */ (/** @type {HTMLElement} */ (this.BookingSuccess))
   if (BookingSuccess) {
    const bookingSuccess = Concealed.control(BookingSuccess, { shadow: true })
    bookingSuccess.setDerivedState({
     /** @this {ru.hulkmoto.IBookingColumnController} */
     get concealed() {
      return !this.bookingState.booking_id
     } }, this)
   }
   const BookingLoader = /** @type {guest.maurice.ui.Concealed} */ (/** @type {HTMLElement} */ (this.BookingLoader))
   if (BookingLoader) {
    const bookingLoader = Concealed.control(BookingLoader, { shadow: true })
    bookingLoader.setDerivedState({
     /** @this {ru.hulkmoto.IBookingColumnController} */
     get concealed() {
      return !this.bookingLoader.state.loading
     } }, this)
   }
   const HaveAccount = /** @type {guest.maurice.ui.Concealed} */ (/** @type {HTMLElement} */ (this.HaveAccount))
   if (HaveAccount) {
    const haveAccount = Concealed.control(HaveAccount, { shadow: true })
    haveAccount.setDerivedState({
     /** @this {ru.hulkmoto.IBookingColumnController} */
     get concealed() {
      return !['signup-request', 'signup'].includes(this.state.uiState)
     } }, this)
   }
   const AuthoriseLink = /** @type {guest.maurice.ui.Concealed} */ (/** @type {HTMLElement} */ (this.AuthoriseLink))
   if (AuthoriseLink) {
    AuthoriseLink.addEventListener('click', (ev) => {
     ev.preventDefault()
     this.switchUiState('login')
     return false
    })
   }
   const NoAccount = /** @type {guest.maurice.ui.Concealed} */ (/** @type {HTMLElement} */ (this.NoAccount))
   if (NoAccount) {
    const noAccount = Concealed.control(NoAccount, { shadow: true })
    noAccount.setDerivedState({
     /** @this {ru.hulkmoto.IBookingColumnController} */
     get concealed() {
      return !['login'].includes(this.state.uiState)
     } }, this)
   }
   const RegisterLink = /** @type {guest.maurice.ui.Concealed} */ (/** @type {HTMLElement} */ (this.RegisterLink))
   if (RegisterLink) {
    RegisterLink.addEventListener('click', (ev) => {
     ev.preventDefault()
     this.switchUiState('signup')
     return false
    })
   }
   const AuthInfo = /** @type {guest.maurice.ui.Concealed} */ (/** @type {HTMLElement} */ (this.AuthInfo))
   if (AuthInfo) {
    const authInfo = Concealed.control(AuthInfo, { shadow: true })
    authInfo.setDerivedState({
     /** @this {ru.hulkmoto.IBookingColumnController} */
     get concealed() {
      return this.state.uiState != 'user'
     } }, this)
   }
   const SignOutButton = /** @type {guest.maurice.ui.Concealed} */ (/** @type {HTMLElement} */ (this.SignOutButton))
   if (SignOutButton) {
    SignOutButton.addEventListener('click', (ev) => {
     ev.preventDefault()
     this.signout()
     return false
    })
   }
   const AuthWarning = /** @type {guest.maurice.ui.Concealed} */ (/** @type {HTMLElement} */ (this.AuthWarning))
   if (AuthWarning) {
    const authWarning = Concealed.control(AuthWarning, { shadow: true })
    authWarning.setDerivedState({
     /** @this {ru.hulkmoto.IBookingColumnController} */
     get concealed() {
      return this.state.uiState == 'user'
     } }, this)
   }
  }, 1)
 },
 get ColumnHolder() {
  return this[BookingColumnControllerChildrenSymbols._ColumnHolder]
 },
 get Start() {
  return this[BookingColumnControllerChildrenSymbols._Start]
 },
 get StartDate() {
  return this[BookingColumnControllerChildrenSymbols._StartDate]
 },
 get StartTime() {
  return this[BookingColumnControllerChildrenSymbols._StartTime]
 },
 get End() {
  return this[BookingColumnControllerChildrenSymbols._End]
 },
 get EndDate() {
  return this[BookingColumnControllerChildrenSymbols._EndDate]
 },
 get EndTime() {
  return this[BookingColumnControllerChildrenSymbols._EndTime]
 },
 get TariffLoading() {
  return this[BookingColumnControllerChildrenSymbols._TariffLoading]
 },
 get TariffOuter() {
  return this[BookingColumnControllerChildrenSymbols._TariffOuter]
 },
 get Tariff() {
  return this[BookingColumnControllerChildrenSymbols._Tariff]
 },
 get DiscountRow() {
  return this[BookingColumnControllerChildrenSymbols._DiscountRow]
 },
 get TotalPrice() {
  return this[BookingColumnControllerChildrenSymbols._TotalPrice]
 },
 get UnavailableFeedback() {
  return this[BookingColumnControllerChildrenSymbols._UnavailableFeedback]
 },
 get TariffLoaderFeedback() {
  return this[BookingColumnControllerChildrenSymbols._TariffLoaderFeedback]
 },
 get TariffLoaderError() {
  return this[BookingColumnControllerChildrenSymbols._TariffLoaderError]
 },
 get SignupFormContainer() {
  return this[BookingColumnControllerChildrenSymbols._SignupFormContainer]
 },
 get SignupForm() {
  return this[BookingColumnControllerChildrenSymbols._SignupForm]
 },
 get LoginFormContainer() {
  return this[BookingColumnControllerChildrenSymbols._LoginFormContainer]
 },
 get LoginForm() {
  return this[BookingColumnControllerChildrenSymbols._LoginForm]
 },
 get RegisterButton() {
  return this[BookingColumnControllerChildrenSymbols._RegisterButton]
 },
 get WhatsAppButton() {
  return this[BookingColumnControllerChildrenSymbols._WhatsAppButton]
 },
 get PayButton() {
  return this[BookingColumnControllerChildrenSymbols._PayButton]
 },
 get BookingLoaderError() {
  return this[BookingColumnControllerChildrenSymbols._BookingLoaderError]
 },
 get BookingSuccess() {
  return this[BookingColumnControllerChildrenSymbols._BookingSuccess]
 },
 get BookingId() {
  return this[BookingColumnControllerChildrenSymbols._BookingId]
 },
 get BookingLoader() {
  return this[BookingColumnControllerChildrenSymbols._BookingLoader]
 },
 get HaveAccount() {
  return this[BookingColumnControllerChildrenSymbols._HaveAccount]
 },
 get AuthoriseLink() {
  return this[BookingColumnControllerChildrenSymbols._AuthoriseLink]
 },
 get NoAccount() {
  return this[BookingColumnControllerChildrenSymbols._NoAccount]
 },
 get RegisterLink() {
  return this[BookingColumnControllerChildrenSymbols._RegisterLink]
 },
 get AuthInfo() {
  return this[BookingColumnControllerChildrenSymbols._AuthInfo]
 },
 get UserName() {
  return this[BookingColumnControllerChildrenSymbols._UserName]
 },
 get SignOutButton() {
  return this[BookingColumnControllerChildrenSymbols._SignOutButton]
 },
 get AuthWarning() {
  return this[BookingColumnControllerChildrenSymbols._AuthWarning]
 },
 get AcceptPrivacyText() {
  return this[BookingColumnControllerChildrenSymbols._AcceptPrivacyText]
 },
})
export const BookingColumnControllerChildrenSymbols = {
 _ColumnHolder: makeClassSymbol(BookingColumnControllerChildren, '_ColumnHolder'),
 _Start: makeClassSymbol(BookingColumnControllerChildren, '_Start'),
 _StartDate: makeClassSymbol(BookingColumnControllerChildren, '_StartDate'),
 _StartTime: makeClassSymbol(BookingColumnControllerChildren, '_StartTime'),
 _End: makeClassSymbol(BookingColumnControllerChildren, '_End'),
 _EndDate: makeClassSymbol(BookingColumnControllerChildren, '_EndDate'),
 _EndTime: makeClassSymbol(BookingColumnControllerChildren, '_EndTime'),
 _TariffLoading: makeClassSymbol(BookingColumnControllerChildren, '_TariffLoading'),
 _TariffOuter: makeClassSymbol(BookingColumnControllerChildren, '_TariffOuter'),
 _Tariff: makeClassSymbol(BookingColumnControllerChildren, '_Tariff'),
 _DiscountRow: makeClassSymbol(BookingColumnControllerChildren, '_DiscountRow'),
 _TotalPrice: makeClassSymbol(BookingColumnControllerChildren, '_TotalPrice'),
 _UnavailableFeedback: makeClassSymbol(BookingColumnControllerChildren, '_UnavailableFeedback'),
 _TariffLoaderFeedback: makeClassSymbol(BookingColumnControllerChildren, '_TariffLoaderFeedback'),
 _TariffLoaderError: makeClassSymbol(BookingColumnControllerChildren, '_TariffLoaderError'),
 _SignupFormContainer: makeClassSymbol(BookingColumnControllerChildren, '_SignupFormContainer'),
 _SignupForm: makeClassSymbol(BookingColumnControllerChildren, '_SignupForm'),
 _LoginFormContainer: makeClassSymbol(BookingColumnControllerChildren, '_LoginFormContainer'),
 _LoginForm: makeClassSymbol(BookingColumnControllerChildren, '_LoginForm'),
 _RegisterButton: makeClassSymbol(BookingColumnControllerChildren, '_RegisterButton'),
 _WhatsAppButton: makeClassSymbol(BookingColumnControllerChildren, '_WhatsAppButton'),
 _PayButton: makeClassSymbol(BookingColumnControllerChildren, '_PayButton'),
 _BookingLoaderError: makeClassSymbol(BookingColumnControllerChildren, '_BookingLoaderError'),
 _BookingSuccess: makeClassSymbol(BookingColumnControllerChildren, '_BookingSuccess'),
 _BookingId: makeClassSymbol(BookingColumnControllerChildren, '_BookingId'),
 _BookingLoader: makeClassSymbol(BookingColumnControllerChildren, '_BookingLoader'),
 _HaveAccount: makeClassSymbol(BookingColumnControllerChildren, '_HaveAccount'),
 _AuthoriseLink: makeClassSymbol(BookingColumnControllerChildren, '_AuthoriseLink'),
 _NoAccount: makeClassSymbol(BookingColumnControllerChildren, '_NoAccount'),
 _RegisterLink: makeClassSymbol(BookingColumnControllerChildren, '_RegisterLink'),
 _AuthInfo: makeClassSymbol(BookingColumnControllerChildren, '_AuthInfo'),
 _UserName: makeClassSymbol(BookingColumnControllerChildren, '_UserName'),
 _SignOutButton: makeClassSymbol(BookingColumnControllerChildren, '_SignOutButton'),
 _AuthWarning: makeClassSymbol(BookingColumnControllerChildren, '_AuthWarning'),
 _AcceptPrivacyText: makeClassSymbol(BookingColumnControllerChildren, '_AcceptPrivacyText'),
}

/** @type {ru.hulkmoto.getBookingColumnControllerChildrenSymbols} */
export const getBookingColumnControllerChildrenSymbols = (instance) => {
 return /** @type {!ru.hulkmoto.IBookingColumnControllerChildrenSymbolsOut} */ (getSymbols(instance, BookingColumnControllerChildrenSymbols))
}
/** @type {ru.hulkmoto.setBookingColumnControllerChildrenSymbols} */
export const setBookingColumnControllerChildrenSymbols = (instance, symbols) => {
 setSymbols(instance, symbols, BookingColumnControllerChildrenSymbols)
}

AbstractBookingColumnController.__implement(__AbstractBookingColumnController, BookingColumnControllerChildren, BuildingBlock)

/**
 * @abstract
 * @extends {ru.hulkmoto.SignupFormController}
 */
class _AbstractSignupFormController {
 constructor() {
  construct(this)
 }
 /** @nocollapse */
 static control(el, opts) {
  const AllSymbols = { ...SignupFormControllerSymbols, ...UserLoadererSymbols }
  /** @suppress {checkTypes} */
  const res = control(this, el, opts, AllSymbols)
  return /** @type {!ru.hulkmoto.SignupFormController} */ (res)
 }
}
/**
 * The controller for the sign-up form.
 * @extends {ru.hulkmoto.SignupFormController} ‎
 * @implements {ru.hulkmoto.ISignupFormController} ‎
 */
export class AbstractSignupFormController extends _AbstractSignupFormController {

}
initAbstract(_AbstractSignupFormController, 'ISignupFormController', /** @this {AbstractSignupFormController} */ function () {
 const { superStateful: { setState, initialState } } = this
 const state = {
  success: '',
  ...initialState,
 }
 proxifyState(state)
 setState(state)
})
/** @constructor @extends {_AbstractSignupFormController} @suppress {checkTypes} */ function __AbstractSignupFormController() {}
__AbstractSignupFormController.prototype = /** @type {!_AbstractSignupFormController} */ ({
 get asISignupFormController() {
  return /** @type {!ru.hulkmoto.BoundISignupFormController} */ (this)
 },
 get superISignupFormController() {
  return /** @type {!ru.hulkmoto.BoundISignupFormController} */ (bindPrototype(_AbstractSignupFormController, this))
 },
 get superSignupFormController() {
  return /** @type {!ru.hulkmoto.BoundSignupFormController} */ (bindPrototype(_AbstractSignupFormController, this))
 },
})
export const SignupFormControllerSymbols = {
 __: makeClassSymbol(AbstractSignupFormController, '__'),
}

/** @type {ru.hulkmoto.getSignupFormControllerSymbols} */
export const getSignupFormControllerSymbols = (instance) => {
 return /** @type {!ru.hulkmoto.ISignupFormControllerSymbolsOut} */ (getSymbols(instance, SignupFormControllerSymbols))
}
/** @type {ru.hulkmoto.setSignupFormControllerSymbols} */
export const setSignupFormControllerSymbols = (instance, symbols) => {
 setSymbols(instance, symbols, SignupFormControllerSymbols)
}

/** @constructor @extends {ru.hulkmoto.SignupFormController} @suppress {checkTypes} */ function SignupFormControllerChildren() {}
SignupFormControllerChildren.prototype = /** @type {!ru.hulkmoto.SignupFormController} */ ({
 /** @return {void} */
 __$constructor() {
  const children = getDataIds(this)
  setSignupFormControllerChildrenSymbols(this, {
   _FormSignup: /** @type {HTMLFormElement} */ (children['FormSignup']),
   _NameInput: /** @type {HTMLInputElement} */ (children['NameInput']),
   _PhoneInput: /** @type {HTMLInputElement} */ (children['PhoneInput']),
   _PasswordInput: /** @type {HTMLInputElement} */ (children['PasswordInput']),
   _RegisterError: /** @type {HTMLSpanElement} */ (children['RegisterError']),
   _RegisterSuccess: /** @type {HTMLSpanElement} */ (children['RegisterSuccess']),
   _SigningUpLoader: /** @type {HTMLDivElement} */ (children['SigningUpLoader']),
   _SignupButton: /** @type {HTMLButtonElement} */ (children['SignupButton']),
  })
  setTimeout(() => {
   const SigningUpLoader = /** @type {guest.maurice.ui.Concealed} */ (/** @type {HTMLElement} */ (this.SigningUpLoader))
   if (SigningUpLoader) {
    const signingUpLoader = Concealed.control(SigningUpLoader, { shadow: true })
    signingUpLoader.setDerivedState({
     /** @this {ru.hulkmoto.ISignupFormController} */
     get concealed() {
      return !this.userLoader.state.loading
     } }, this)
   }
   const SignupButton = /** @type {guest.maurice.ui.Concealed} */ (/** @type {HTMLElement} */ (this.SignupButton))
   if (SignupButton) {
    SignupButton.addEventListener('click', (ev) => {
     ev.preventDefault()
     this.createUser()
     return false
    })
   }
  }, 1)
 },
 get FormSignup() {
  return this[SignupFormControllerChildrenSymbols._FormSignup]
 },
 get NameInput() {
  return this[SignupFormControllerChildrenSymbols._NameInput]
 },
 get PhoneInput() {
  return this[SignupFormControllerChildrenSymbols._PhoneInput]
 },
 get PasswordInput() {
  return this[SignupFormControllerChildrenSymbols._PasswordInput]
 },
 get RegisterError() {
  return this[SignupFormControllerChildrenSymbols._RegisterError]
 },
 get RegisterSuccess() {
  return this[SignupFormControllerChildrenSymbols._RegisterSuccess]
 },
 get SigningUpLoader() {
  return this[SignupFormControllerChildrenSymbols._SigningUpLoader]
 },
 get SignupButton() {
  return this[SignupFormControllerChildrenSymbols._SignupButton]
 },
})
export const SignupFormControllerChildrenSymbols = {
 _FormSignup: makeClassSymbol(SignupFormControllerChildren, '_FormSignup'),
 _NameInput: makeClassSymbol(SignupFormControllerChildren, '_NameInput'),
 _PhoneInput: makeClassSymbol(SignupFormControllerChildren, '_PhoneInput'),
 _PasswordInput: makeClassSymbol(SignupFormControllerChildren, '_PasswordInput'),
 _RegisterError: makeClassSymbol(SignupFormControllerChildren, '_RegisterError'),
 _RegisterSuccess: makeClassSymbol(SignupFormControllerChildren, '_RegisterSuccess'),
 _SigningUpLoader: makeClassSymbol(SignupFormControllerChildren, '_SigningUpLoader'),
 _SignupButton: makeClassSymbol(SignupFormControllerChildren, '_SignupButton'),
}

/** @type {ru.hulkmoto.getSignupFormControllerChildrenSymbols} */
export const getSignupFormControllerChildrenSymbols = (instance) => {
 return /** @type {!ru.hulkmoto.ISignupFormControllerChildrenSymbolsOut} */ (getSymbols(instance, SignupFormControllerChildrenSymbols))
}
/** @type {ru.hulkmoto.setSignupFormControllerChildrenSymbols} */
export const setSignupFormControllerChildrenSymbols = (instance, symbols) => {
 setSymbols(instance, symbols, SignupFormControllerChildrenSymbols)
}

AbstractSignupFormController.__implement(__AbstractSignupFormController, SignupFormControllerChildren, BuildingBlock)

/**
 * @abstract
 * @extends {ru.hulkmoto.LoginFormController}
 */
class _AbstractLoginFormController {
 constructor() {
  construct(this)
 }
 /** @nocollapse */
 static control(el, opts) {
  const AllSymbols = { ...LoginFormControllerSymbols, ...UserLoadererSymbols }
  /** @suppress {checkTypes} */
  const res = control(this, el, opts, AllSymbols)
  return /** @type {!ru.hulkmoto.LoginFormController} */ (res)
 }
}
/**
 * The controller for the login form.
 * @extends {ru.hulkmoto.LoginFormController} ‎
 * @implements {ru.hulkmoto.ILoginFormController} ‎
 */
export class AbstractLoginFormController extends _AbstractLoginFormController {

}
initAbstract(_AbstractLoginFormController, 'ILoginFormController', /** @this {AbstractLoginFormController} */ function () {
 const { superStateful: { setState, initialState } } = this
 const state = {
  success: '',
  ...initialState,
 }
 proxifyState(state)
 setState(state)
})
/** @constructor @extends {_AbstractLoginFormController} @suppress {checkTypes} */ function __AbstractLoginFormController() {}
__AbstractLoginFormController.prototype = /** @type {!_AbstractLoginFormController} */ ({
 get asILoginFormController() {
  return /** @type {!ru.hulkmoto.BoundILoginFormController} */ (this)
 },
 get superILoginFormController() {
  return /** @type {!ru.hulkmoto.BoundILoginFormController} */ (bindPrototype(_AbstractLoginFormController, this))
 },
 get superLoginFormController() {
  return /** @type {!ru.hulkmoto.BoundLoginFormController} */ (bindPrototype(_AbstractLoginFormController, this))
 },
})
export const LoginFormControllerSymbols = {
 __: makeClassSymbol(AbstractLoginFormController, '__'),
}

/** @type {ru.hulkmoto.getLoginFormControllerSymbols} */
export const getLoginFormControllerSymbols = (instance) => {
 return /** @type {!ru.hulkmoto.ILoginFormControllerSymbolsOut} */ (getSymbols(instance, LoginFormControllerSymbols))
}
/** @type {ru.hulkmoto.setLoginFormControllerSymbols} */
export const setLoginFormControllerSymbols = (instance, symbols) => {
 setSymbols(instance, symbols, LoginFormControllerSymbols)
}

/** @constructor @extends {ru.hulkmoto.LoginFormController} @suppress {checkTypes} */ function LoginFormControllerChildren() {}
LoginFormControllerChildren.prototype = /** @type {!ru.hulkmoto.LoginFormController} */ ({
 /** @return {void} */
 __$constructor() {
  const children = getDataIds(this)
  setLoginFormControllerChildrenSymbols(this, {
   _LoginForm: /** @type {HTMLFormElement} */ (children['LoginForm']),
   _PhoneInput: /** @type {HTMLInputElement} */ (children['PhoneInput']),
   _PasswordInput: /** @type {HTMLInputElement} */ (children['PasswordInput']),
   _LoginError: /** @type {HTMLSpanElement} */ (children['LoginError']),
   _LoginSuccess: /** @type {HTMLSpanElement} */ (children['LoginSuccess']),
   _AccountLoader: /** @type {HTMLDivElement} */ (children['AccountLoader']),
   _LoginButton: /** @type {HTMLButtonElement} */ (children['LoginButton']),
  })
  setTimeout(() => {
   const AccountLoader = /** @type {guest.maurice.ui.Concealed} */ (/** @type {HTMLElement} */ (this.AccountLoader))
   if (AccountLoader) {
    const accountLoader = Concealed.control(AccountLoader, { shadow: true })
    accountLoader.setDerivedState({
     /** @this {ru.hulkmoto.ILoginFormController} */
     get concealed() {
      return !this.userLoader.state.loading
     } }, this)
   }
   const LoginButton = /** @type {guest.maurice.ui.Concealed} */ (/** @type {HTMLElement} */ (this.LoginButton))
   if (LoginButton) {
    LoginButton.addEventListener('click', (ev) => {
     ev.preventDefault()
     this.signIn()
     return false
    })
   }
  }, 1)
 },
 get LoginForm() {
  return this[LoginFormControllerChildrenSymbols._LoginForm]
 },
 get PhoneInput() {
  return this[LoginFormControllerChildrenSymbols._PhoneInput]
 },
 get PasswordInput() {
  return this[LoginFormControllerChildrenSymbols._PasswordInput]
 },
 get LoginError() {
  return this[LoginFormControllerChildrenSymbols._LoginError]
 },
 get LoginSuccess() {
  return this[LoginFormControllerChildrenSymbols._LoginSuccess]
 },
 get AccountLoader() {
  return this[LoginFormControllerChildrenSymbols._AccountLoader]
 },
 get LoginButton() {
  return this[LoginFormControllerChildrenSymbols._LoginButton]
 },
})
export const LoginFormControllerChildrenSymbols = {
 _LoginForm: makeClassSymbol(LoginFormControllerChildren, '_LoginForm'),
 _PhoneInput: makeClassSymbol(LoginFormControllerChildren, '_PhoneInput'),
 _PasswordInput: makeClassSymbol(LoginFormControllerChildren, '_PasswordInput'),
 _LoginError: makeClassSymbol(LoginFormControllerChildren, '_LoginError'),
 _LoginSuccess: makeClassSymbol(LoginFormControllerChildren, '_LoginSuccess'),
 _AccountLoader: makeClassSymbol(LoginFormControllerChildren, '_AccountLoader'),
 _LoginButton: makeClassSymbol(LoginFormControllerChildren, '_LoginButton'),
}

/** @type {ru.hulkmoto.getLoginFormControllerChildrenSymbols} */
export const getLoginFormControllerChildrenSymbols = (instance) => {
 return /** @type {!ru.hulkmoto.ILoginFormControllerChildrenSymbolsOut} */ (getSymbols(instance, LoginFormControllerChildrenSymbols))
}
/** @type {ru.hulkmoto.setLoginFormControllerChildrenSymbols} */
export const setLoginFormControllerChildrenSymbols = (instance, symbols) => {
 setSymbols(instance, symbols, LoginFormControllerChildrenSymbols)
}

AbstractLoginFormController.__implement(__AbstractLoginFormController, LoginFormControllerChildren, BuildingBlock)

/**
 * @abstract
 * @extends {ru.hulkmoto.TariffLoader}
 */
class _AbstractTariffLoader {
 constructor() {
  construct(this)
 }
}
/**
 * The bike loader to display info about prices.
 * @extends {ru.hulkmoto.TariffLoader} ‎
 * @implements {ru.hulkmoto.ITariffLoader} ‎
 */
export class AbstractTariffLoader extends _AbstractTariffLoader {

}
initAbstract(_AbstractTariffLoader, 'ITariffLoader', /** @this {AbstractTariffLoader} */ function () {
 const { superStateful: { setState, initialState } } = this
 const state = {
  twelveHourDiscount: null,
  dailyDiscount: null,
  dailyPrice: null,
  fiveHourPrice: null,
  twelveHourPrice: null,
  nightlyPrice: null,
  inventoryState: null,
  ...initialState,
 }
 proxifyState(state)
 setState(state)
})
/** @constructor @extends {_AbstractTariffLoader} @suppress {checkTypes} */ function __AbstractTariffLoader() {}
__AbstractTariffLoader.prototype = /** @type {!_AbstractTariffLoader} */ ({
 get asITariffLoader() {
  return /** @type {!ru.hulkmoto.BoundITariffLoader} */ (this)
 },
 get superITariffLoader() {
  return /** @type {!ru.hulkmoto.BoundITariffLoader} */ (bindPrototype(_AbstractTariffLoader, this))
 },
 get superTariffLoader() {
  return /** @type {!ru.hulkmoto.BoundTariffLoader} */ (bindPrototype(_AbstractTariffLoader, this))
 },
})
/** @constructor @extends {ru.hulkmoto.TariffLoaderer} @suppress {checkTypes} */ function AbstractTariffLoaderer() {}
AbstractTariffLoaderer.prototype = /** @type {!ru.hulkmoto.TariffLoaderer} */ ({
 /** @return {void} */
 __$constructor() {
  const { _tariffLoader } = getTariffLoadererSymbols(this)
  setTariffLoadererSymbols(this, {
   _tariffLoader: iu(_tariffLoader, null),
  })
 },
 get tariffLoader() {
  return this[TariffLoadererSymbols._tariffLoader]
 },
 get asITariffLoaderer() {
  return /** @type {!ru.hulkmoto.BoundITariffLoaderer} */ (this)
 },
 get superITariffLoaderer() {
  return /** @type {!ru.hulkmoto.BoundITariffLoaderer} */ (bindPrototype(AbstractTariffLoaderer, this))
 },
 get superTariffLoaderer() {
  return /** @type {!ru.hulkmoto.BoundTariffLoaderer} */ (bindPrototype(AbstractTariffLoaderer, this))
 },
})
export const TariffLoadererSymbols = {
 _tariffLoader: makeClassSymbol(AbstractTariffLoaderer, '_tariffLoader'),
}

/** @type {ru.hulkmoto.getTariffLoadererSymbols} */
export const getTariffLoadererSymbols = (instance) => {
 return /** @type {!ru.hulkmoto.ITariffLoadererSymbolsOut} */ (getSymbols(instance, TariffLoadererSymbols))
}
/** @type {ru.hulkmoto.setTariffLoadererSymbols} */
export const setTariffLoadererSymbols = (instance, symbols) => {
 setSymbols(instance, symbols, TariffLoadererSymbols)
}

export { AbstractTariffLoaderer }
AbstractTariffLoader.__implement(__AbstractTariffLoader, AbstractTariffLoaderer, BuildingBlock)

/**
 * @abstract
 * @extends {ru.hulkmoto.UserLoader}
 */
class _AbstractUserLoader {
 constructor() {
  construct(this)
 }
}
/**
 * The user loader to display info about the current user.
 * @extends {ru.hulkmoto.UserLoader} ‎
 * @implements {ru.hulkmoto.IUserLoader} ‎
 */
export class AbstractUserLoader extends _AbstractUserLoader {

}
initAbstract(_AbstractUserLoader, 'IUserLoader', /** @this {AbstractUserLoader} */ function () {
 const { superStateful: { setState, initialState } } = this
 const state = {
  user: null,
  ...initialState,
 }
 proxifyState(state)
 setState(state)
})
/** @constructor @extends {_AbstractUserLoader} @suppress {checkTypes} */ function __AbstractUserLoader() {}
__AbstractUserLoader.prototype = /** @type {!_AbstractUserLoader} */ ({
 get asIUserLoader() {
  return /** @type {!ru.hulkmoto.BoundIUserLoader} */ (this)
 },
 get superIUserLoader() {
  return /** @type {!ru.hulkmoto.BoundIUserLoader} */ (bindPrototype(_AbstractUserLoader, this))
 },
 get superUserLoader() {
  return /** @type {!ru.hulkmoto.BoundUserLoader} */ (bindPrototype(_AbstractUserLoader, this))
 },
})
/** @constructor @extends {ru.hulkmoto.UserLoaderer} @suppress {checkTypes} */ function AbstractUserLoaderer() {}
AbstractUserLoaderer.prototype = /** @type {!ru.hulkmoto.UserLoaderer} */ ({
 /** @return {void} */
 __$constructor() {
  const { _userLoader } = getUserLoadererSymbols(this)
  setUserLoadererSymbols(this, {
   _userLoader: iu(_userLoader, null),
  })
 },
 get userLoader() {
  return this[UserLoadererSymbols._userLoader]
 },
 get asIUserLoaderer() {
  return /** @type {!ru.hulkmoto.BoundIUserLoaderer} */ (this)
 },
 get superIUserLoaderer() {
  return /** @type {!ru.hulkmoto.BoundIUserLoaderer} */ (bindPrototype(AbstractUserLoaderer, this))
 },
 get superUserLoaderer() {
  return /** @type {!ru.hulkmoto.BoundUserLoaderer} */ (bindPrototype(AbstractUserLoaderer, this))
 },
})
export const UserLoadererSymbols = {
 _userLoader: makeClassSymbol(AbstractUserLoaderer, '_userLoader'),
}

/** @type {ru.hulkmoto.getUserLoadererSymbols} */
export const getUserLoadererSymbols = (instance) => {
 return /** @type {!ru.hulkmoto.IUserLoadererSymbolsOut} */ (getSymbols(instance, UserLoadererSymbols))
}
/** @type {ru.hulkmoto.setUserLoadererSymbols} */
export const setUserLoadererSymbols = (instance, symbols) => {
 setSymbols(instance, symbols, UserLoadererSymbols)
}

export { AbstractUserLoaderer }
AbstractUserLoader.__implement(__AbstractUserLoader, AbstractUserLoaderer, BuildingBlock)

/**
 * @abstract
 * @extends {ru.hulkmoto.BookingController}
 */
class _AbstractBookingController {
 constructor() {
  construct(this)
 }
 /** @nocollapse */
 static control(el, opts) {
  const AllSymbols = BookingControllerSymbols
  /** @suppress {checkTypes} */
  const res = control(this, el, opts, AllSymbols)
  return /** @type {!ru.hulkmoto.BookingController} */ (res)
 }
}
/**
 * The controller for the form.
 * @extends {ru.hulkmoto.BookingController} ‎
 * @implements {ru.hulkmoto.IBookingController} ‎
 */
export class AbstractBookingController extends _AbstractBookingController {

}
initAbstract(_AbstractBookingController, 'IBookingController', /** @this {AbstractBookingController} */ function () {
 const { _availabilityLoader, _bookingLoader } = getBookingControllerSymbols(this)
 setBookingControllerSymbols(this, {
  _availabilityLoader: iu(_availabilityLoader, null),
  _bookingLoader: iu(_bookingLoader, null),
 })
 const { superStateful: { setState, initialState } } = this
 const state = {
  currentTariff: 'day',
  booking_id: '',
  privacy_accepted: true,
  ...initialState,
 }
 proxifyState(state)
 setState(state)
})
/** @constructor @extends {_AbstractBookingController} @suppress {checkTypes} */ function __AbstractBookingController() {}
__AbstractBookingController.prototype = /** @type {!_AbstractBookingController} */ ({
 get availabilityLoader() {
  return this[BookingControllerSymbols._availabilityLoader]
 },
 get bookingLoader() {
  return this[BookingControllerSymbols._bookingLoader]
 },
 get asIBookingController() {
  return /** @type {!ru.hulkmoto.BoundIBookingController} */ (this)
 },
 get superIBookingController() {
  return /** @type {!ru.hulkmoto.BoundIBookingController} */ (bindPrototype(_AbstractBookingController, this))
 },
 get superBookingController() {
  return /** @type {!ru.hulkmoto.BoundBookingController} */ (bindPrototype(_AbstractBookingController, this))
 },
})
export const BookingControllerSymbols = {
 _availabilityLoader: makeClassSymbol(AbstractBookingController, '_availabilityLoader'),
 _bookingLoader: makeClassSymbol(AbstractBookingController, '_bookingLoader'),
}

/** @type {ru.hulkmoto.getBookingControllerSymbols} */
export const getBookingControllerSymbols = (instance) => {
 return /** @type {!ru.hulkmoto.IBookingControllerSymbolsOut} */ (getSymbols(instance, BookingControllerSymbols))
}
/** @type {ru.hulkmoto.setBookingControllerSymbols} */
export const setBookingControllerSymbols = (instance, symbols) => {
 setSymbols(instance, symbols, BookingControllerSymbols)
}

/** @constructor @extends {ru.hulkmoto.BookingController} @suppress {checkTypes} */ function BookingControllerChildren() {}
BookingControllerChildren.prototype = /** @type {!ru.hulkmoto.BookingController} */ ({
 /** @return {void} */
 __$constructor() {
  const children = getDataIds(this)
  setBookingControllerChildrenSymbols(this, {
   _HintHours: /** @type {HTMLElement} */ (children['HintHours']),
   _HintDay: /** @type {HTMLElement} */ (children['HintDay']),
   _HintTwentyFour: /** @type {HTMLElement} */ (children['HintTwentyFour']),
   _HintNight: /** @type {HTMLElement} */ (children['HintNight']),
   _FirstSelectDateRange: /** @type {HTMLSpanElement} */ (children['FirstSelectDateRange']),
   _FirstSelectDateSingle: /** @type {HTMLSpanElement} */ (children['FirstSelectDateSingle']),
   _Planner: /** @type {ru.hulkmoto.PlannerController} */ (children['Planner']),
   _StartDate: /** @type {HTMLSpanElement} */ (children['StartDate']),
   _StartTime: /** @type {HTMLSpanElement} */ (children['StartTime']),
   _EndDate: /** @type {HTMLSpanElement} */ (children['EndDate']),
   _EndTime: /** @type {HTMLSpanElement} */ (children['EndTime']),
   _PrivacyCheckbox: /** @type {HTMLInputElement} */ (children['PrivacyCheckbox']),
   _AvailabilityLoader: /** @type {HTMLDivElement} */ (children['AvailabilityLoader']),
   _FiveHours: /** @type {HTMLSpanElement} */ (children['FiveHours']),
   _TwentyFourHours: /** @type {HTMLSpanElement} */ (children['TwentyFourHours']),
   _Day: /** @type {HTMLSpanElement} */ (children['Day']),
   _Night: /** @type {HTMLSpanElement} */ (children['Night']),
   _BookingColumn: /** @type {ru.hulkmoto.BookingColumnController} */ (children['BookingColumn']),
   _Calendar: /** @type {ru.hulkmoto.CalendarController} */ (children['Calendar']),
  })
  setTimeout(() => {
   const HintHours = /** @type {guest.maurice.ui.Concealed} */ (/** @type {HTMLElement} */ (this.HintHours))
   if (HintHours) {
    const hintHours = Concealed.control(HintHours, { shadow: true })
    hintHours.setDerivedState({
     /** @this {ru.hulkmoto.IBookingController} */
     get concealed() {
      return this.state.currentTariff!='fiveHours'
     } }, this)
   }
   const HintDay = /** @type {guest.maurice.ui.Concealed} */ (/** @type {HTMLElement} */ (this.HintDay))
   if (HintDay) {
    const hintDay = Concealed.control(HintDay, { shadow: true })
    hintDay.setDerivedState({
     /** @this {ru.hulkmoto.IBookingController} */
     get concealed() {
      return this.state.currentTariff!='day'
     } }, this)
   }
   const HintTwentyFour = /** @type {guest.maurice.ui.Concealed} */ (/** @type {HTMLElement} */ (this.HintTwentyFour))
   if (HintTwentyFour) {
    const hintTwentyFour = Concealed.control(HintTwentyFour, { shadow: true })
    hintTwentyFour.setDerivedState({
     /** @this {ru.hulkmoto.IBookingController} */
     get concealed() {
      return this.state.currentTariff!='twentyFourHours'
     } }, this)
   }
   const HintNight = /** @type {guest.maurice.ui.Concealed} */ (/** @type {HTMLElement} */ (this.HintNight))
   if (HintNight) {
    const hintNight = Concealed.control(HintNight, { shadow: true })
    hintNight.setDerivedState({
     /** @this {ru.hulkmoto.IBookingController} */
     get concealed() {
      return this.state.currentTariff!='night'
     } }, this)
   }
   const FirstSelectDateRange = /** @type {guest.maurice.ui.Concealed} */ (/** @type {HTMLElement} */ (this.FirstSelectDateRange))
   if (FirstSelectDateRange) {
    const firstSelectDateRange = Concealed.control(FirstSelectDateRange, { shadow: true })
    firstSelectDateRange.setDerivedState({
     /** @this {ru.hulkmoto.IBookingController} */
     get concealed() {
      return !this.showFirstSelectDateRange
     } }, this)
   }
   const FirstSelectDateSingle = /** @type {guest.maurice.ui.Concealed} */ (/** @type {HTMLElement} */ (this.FirstSelectDateSingle))
   if (FirstSelectDateSingle) {
    const firstSelectDateSingle = Concealed.control(FirstSelectDateSingle, { shadow: true })
    firstSelectDateSingle.setDerivedState({
     /** @this {ru.hulkmoto.IBookingController} */
     get concealed() {
      return !this.showFirstSelectDateSingle
     } }, this)
   }
   const Planner = /** @type {guest.maurice.ui.Concealed} */ (/** @type {HTMLElement} */ (this.Planner))
   if (Planner) {
    const planner = Concealed.control(Planner, { shadow: true })
    planner.setDerivedState({
     /** @this {ru.hulkmoto.IBookingController} */
     get concealed() {
      return !this.shouldShowPlanner
     } }, this)
   }
   const StartTime = /** @type {guest.maurice.ui.Concealed} */ (/** @type {HTMLElement} */ (this.StartTime))
   if (StartTime) {
    const startTime = Concealed.control(StartTime, { shadow: true })
    startTime.setDerivedState({
     /** @this {ru.hulkmoto.IBookingController} */
     get concealed() {
      return !this.state.startTime
     } }, this)
   }
   const EndTime = /** @type {guest.maurice.ui.Concealed} */ (/** @type {HTMLElement} */ (this.EndTime))
   if (EndTime) {
    const endTime = Concealed.control(EndTime, { shadow: true })
    endTime.setDerivedState({
     /** @this {ru.hulkmoto.IBookingController} */
     get concealed() {
      return !this.state.endTime
     } }, this)
   }
   const PrivacyCheckbox = /** @type {guest.maurice.ui.Concealed} */ (/** @type {HTMLElement} */ (this.PrivacyCheckbox))
   if (PrivacyCheckbox) {
    PrivacyCheckbox.addEventListener('change', (ev) => {
     this.privacyChange()
    })
   }
   const AvailabilityLoader = /** @type {guest.maurice.ui.Concealed} */ (/** @type {HTMLElement} */ (this.AvailabilityLoader))
   if (AvailabilityLoader) {
    const availabilityLoader = Concealed.control(AvailabilityLoader, { shadow: true })
    availabilityLoader.setDerivedState({
     /** @this {ru.hulkmoto.IBookingController} */
     get concealed() {
      return !this.availabilityLoader.state.loading
     } }, this)
   }
   const FiveHours = /** @type {guest.maurice.ui.Concealed} */ (/** @type {HTMLElement} */ (this.FiveHours))
   if (FiveHours) {
    FiveHours.addEventListener('click', (ev) => {
     window['ym'](gid,'reachGoal','5TariffSell')
     this.switchTariff('fiveHours')
    })
    const classesInfo = /** @type {!ru.hulkmoto.IBookingController.Classes} */ ({
     /** @this {ru.hulkmoto.IBookingController} */
     get SwitchSelected() {
      return this.state.currentTariff == 'fiveHours'
     },
    })
    setupClassSeersDelayed(FiveHours, classesInfo, this)
   }
   const TwentyFourHours = /** @type {guest.maurice.ui.Concealed} */ (/** @type {HTMLElement} */ (this.TwentyFourHours))
   if (TwentyFourHours) {
    TwentyFourHours.addEventListener('click', (ev) => {
     window['ym'](gid,'reachGoal','24TariffSell')
     this.switchTariff('twentyFourHours')
    })
    const classesInfo = /** @type {!ru.hulkmoto.IBookingController.Classes} */ ({
     /** @this {ru.hulkmoto.IBookingController} */
     get SwitchSelected() {
      return this.state.currentTariff == 'twentyFourHours'
     },
    })
    setupClassSeersDelayed(TwentyFourHours, classesInfo, this)
   }
   const Day = /** @type {guest.maurice.ui.Concealed} */ (/** @type {HTMLElement} */ (this.Day))
   if (Day) {
    Day.addEventListener('click', (ev) => {
     window['ym'](gid,'reachGoal','DayTariffSell')
     this.switchTariff('day')
    })
    const classesInfo = /** @type {!ru.hulkmoto.IBookingController.Classes} */ ({
     /** @this {ru.hulkmoto.IBookingController} */
     get SwitchSelected() {
      return this.state.currentTariff == 'day'
     },
    })
    setupClassSeersDelayed(Day, classesInfo, this)
   }
   const Night = /** @type {guest.maurice.ui.Concealed} */ (/** @type {HTMLElement} */ (this.Night))
   if (Night) {
    Night.addEventListener('click', (ev) => {
     window['ym'](gid,'reachGoal','NightTariffSell')
     this.switchTariff('night')
    })
    const classesInfo = /** @type {!ru.hulkmoto.IBookingController.Classes} */ ({
     /** @this {ru.hulkmoto.IBookingController} */
     get SwitchSelected() {
      return this.state.currentTariff == 'night'
     },
    })
    setupClassSeersDelayed(Night, classesInfo, this)
   }
  }, 1)
 },
 get HintHours() {
  return this[BookingControllerChildrenSymbols._HintHours]
 },
 get HintDay() {
  return this[BookingControllerChildrenSymbols._HintDay]
 },
 get HintTwentyFour() {
  return this[BookingControllerChildrenSymbols._HintTwentyFour]
 },
 get HintNight() {
  return this[BookingControllerChildrenSymbols._HintNight]
 },
 get FirstSelectDateRange() {
  return this[BookingControllerChildrenSymbols._FirstSelectDateRange]
 },
 get FirstSelectDateSingle() {
  return this[BookingControllerChildrenSymbols._FirstSelectDateSingle]
 },
 get Planner() {
  return this[BookingControllerChildrenSymbols._Planner]
 },
 get StartDate() {
  return this[BookingControllerChildrenSymbols._StartDate]
 },
 get StartTime() {
  return this[BookingControllerChildrenSymbols._StartTime]
 },
 get EndDate() {
  return this[BookingControllerChildrenSymbols._EndDate]
 },
 get EndTime() {
  return this[BookingControllerChildrenSymbols._EndTime]
 },
 get PrivacyCheckbox() {
  return this[BookingControllerChildrenSymbols._PrivacyCheckbox]
 },
 get AvailabilityLoader() {
  return this[BookingControllerChildrenSymbols._AvailabilityLoader]
 },
 get FiveHours() {
  return this[BookingControllerChildrenSymbols._FiveHours]
 },
 get TwentyFourHours() {
  return this[BookingControllerChildrenSymbols._TwentyFourHours]
 },
 get Day() {
  return this[BookingControllerChildrenSymbols._Day]
 },
 get Night() {
  return this[BookingControllerChildrenSymbols._Night]
 },
 get BookingColumn() {
  return this[BookingControllerChildrenSymbols._BookingColumn]
 },
 get Calendar() {
  return this[BookingControllerChildrenSymbols._Calendar]
 },
})
export const BookingControllerChildrenSymbols = {
 _HintHours: makeClassSymbol(BookingControllerChildren, '_HintHours'),
 _HintDay: makeClassSymbol(BookingControllerChildren, '_HintDay'),
 _HintTwentyFour: makeClassSymbol(BookingControllerChildren, '_HintTwentyFour'),
 _HintNight: makeClassSymbol(BookingControllerChildren, '_HintNight'),
 _FirstSelectDateRange: makeClassSymbol(BookingControllerChildren, '_FirstSelectDateRange'),
 _FirstSelectDateSingle: makeClassSymbol(BookingControllerChildren, '_FirstSelectDateSingle'),
 _Planner: makeClassSymbol(BookingControllerChildren, '_Planner'),
 _StartDate: makeClassSymbol(BookingControllerChildren, '_StartDate'),
 _StartTime: makeClassSymbol(BookingControllerChildren, '_StartTime'),
 _EndDate: makeClassSymbol(BookingControllerChildren, '_EndDate'),
 _EndTime: makeClassSymbol(BookingControllerChildren, '_EndTime'),
 _PrivacyCheckbox: makeClassSymbol(BookingControllerChildren, '_PrivacyCheckbox'),
 _AvailabilityLoader: makeClassSymbol(BookingControllerChildren, '_AvailabilityLoader'),
 _FiveHours: makeClassSymbol(BookingControllerChildren, '_FiveHours'),
 _TwentyFourHours: makeClassSymbol(BookingControllerChildren, '_TwentyFourHours'),
 _Day: makeClassSymbol(BookingControllerChildren, '_Day'),
 _Night: makeClassSymbol(BookingControllerChildren, '_Night'),
 _BookingColumn: makeClassSymbol(BookingControllerChildren, '_BookingColumn'),
 _Calendar: makeClassSymbol(BookingControllerChildren, '_Calendar'),
}

/** @type {ru.hulkmoto.getBookingControllerChildrenSymbols} */
export const getBookingControllerChildrenSymbols = (instance) => {
 return /** @type {!ru.hulkmoto.IBookingControllerChildrenSymbolsOut} */ (getSymbols(instance, BookingControllerChildrenSymbols))
}
/** @type {ru.hulkmoto.setBookingControllerChildrenSymbols} */
export const setBookingControllerChildrenSymbols = (instance, symbols) => {
 setSymbols(instance, symbols, BookingControllerChildrenSymbols)
}

AbstractBookingController.__implement(__AbstractBookingController, BookingControllerChildren, BuildingBlock)

/**
 * @abstract
 * @extends {ru.hulkmoto.CalendarController}
 */
class _AbstractCalendarController {
 constructor() {
  construct(this)
 }
 /** @nocollapse */
 static control(el, opts) {
  const AllSymbols = { ...CalendarControllerSymbols, ...DateRangerSymbols }
  /** @suppress {checkTypes} */
  const res = control(this, el, opts, AllSymbols)
  return /** @type {!ru.hulkmoto.CalendarController} */ (res)
 }
}
/**
 * A calendar.
 * @extends {ru.hulkmoto.CalendarController} ‎
 * @implements {ru.hulkmoto.ICalendarController} ‎
 * @implements {engineering.type.IInitialiser<ru.hulkmoto.ICalendarController, ru.hulkmoto.ICalendarController.Initialese>} ‎
 */
export class AbstractCalendarController extends _AbstractCalendarController {

}
initAbstract(_AbstractCalendarController, 'ICalendarController', /** @this {AbstractCalendarController} */ function () {
 const { __, _today, _availabilityLoader } = getCalendarControllerSymbols(this)
 setCalendarControllerSymbols(this, {
  _availabilityLoader: iu(_availabilityLoader, null),
 })
 const { superStateful: { setState, initialState } } = this
 const state = {
  year: null,
  month: null,
  startHour: null,
  endHour: null,
  endNextDay: false,
  ...initialState,
 }
 proxifyState(state)
 delegateState(state, this)
 setState(state)
})
/** @constructor @extends {_AbstractCalendarController} @suppress {checkTypes} */ function __AbstractCalendarController() {}
__AbstractCalendarController.prototype = /** @type {!_AbstractCalendarController} */ ({
 get today() {
  return this[CalendarControllerSymbols._today]
 },
 get availabilityLoader() {
  return this[CalendarControllerSymbols._availabilityLoader]
 },
 get asICalendarController() {
  return /** @type {!ru.hulkmoto.BoundICalendarController} */ (this)
 },
 get superICalendarController() {
  return /** @type {!ru.hulkmoto.BoundICalendarController} */ (bindPrototype(_AbstractCalendarController, this))
 },
 get superCalendarController() {
  return /** @type {!ru.hulkmoto.BoundCalendarController} */ (bindPrototype(_AbstractCalendarController, this))
 },
})
export const CalendarControllerSymbols = {
 __: makeClassSymbol(AbstractCalendarController, '__'),
 _today: makeClassSymbol(AbstractCalendarController, '_today'),
 _availabilityLoader: makeClassSymbol(AbstractCalendarController, '_availabilityLoader'),
}

/** @type {ru.hulkmoto.getCalendarControllerSymbols} */
export const getCalendarControllerSymbols = (instance) => {
 return /** @type {!ru.hulkmoto.ICalendarControllerSymbolsOut} */ (getSymbols(instance, CalendarControllerSymbols))
}
/** @type {ru.hulkmoto.setCalendarControllerSymbols} */
export const setCalendarControllerSymbols = (instance, symbols) => {
 setSymbols(instance, symbols, CalendarControllerSymbols)
}

/** @constructor @extends {ru.hulkmoto.CalendarController} @suppress {checkTypes} */ function CalendarControllerChildren() {}
CalendarControllerChildren.prototype = /** @type {!ru.hulkmoto.CalendarController} */ ({
 /** @return {void} */
 __$constructor() {
  const children = getDataIds(this)
  setCalendarControllerChildrenSymbols(this, {
   _CalendarHeading: /** @type {HTMLHeadingElement} */ (children['CalendarHeading']),
   _CalendarBody: /** @type {HTMLTableSectionElement} */ (children['CalendarBody']),
  })
  setTimeout(() => {
   const CalendarBody = /** @type {guest.maurice.ui.Concealed} */ (/** @type {HTMLElement} */ (this.CalendarBody))
   if (CalendarBody) {
    const classesInfo = /** @type {!ru.hulkmoto.ICalendarController.Classes} */ ({
     /** @this {ru.hulkmoto.ICalendarController} */
     get RangeSelected() {
      return this.state.uiState == 'selected'
     },
    })
    setupClassSeersDelayed(CalendarBody, classesInfo, this)
   }
  }, 1)
 },
 get CalendarHeading() {
  return this[CalendarControllerChildrenSymbols._CalendarHeading]
 },
 get CalendarBody() {
  return this[CalendarControllerChildrenSymbols._CalendarBody]
 },
})
export const CalendarControllerChildrenSymbols = {
 _CalendarHeading: makeClassSymbol(CalendarControllerChildren, '_CalendarHeading'),
 _CalendarBody: makeClassSymbol(CalendarControllerChildren, '_CalendarBody'),
}

/** @type {ru.hulkmoto.getCalendarControllerChildrenSymbols} */
export const getCalendarControllerChildrenSymbols = (instance) => {
 return /** @type {!ru.hulkmoto.ICalendarControllerChildrenSymbolsOut} */ (getSymbols(instance, CalendarControllerChildrenSymbols))
}
/** @type {ru.hulkmoto.setCalendarControllerChildrenSymbols} */
export const setCalendarControllerChildrenSymbols = (instance, symbols) => {
 setSymbols(instance, symbols, CalendarControllerChildrenSymbols)
}

AbstractCalendarController.__implement(__AbstractCalendarController, CalendarControllerChildren, BuildingBlock)

/**
 * @abstract
 * @extends {ru.hulkmoto.CellController}
 */
class _AbstractCellController {
 constructor() {
  construct(this)
 }
 /** @nocollapse */
 static control(el, opts) {
  const AllSymbols = CellControllerSymbols
  /** @suppress {checkTypes} */
  const res = control(this, el, opts, AllSymbols)
  return /** @type {!ru.hulkmoto.CellController} */ (res)
 }
}
/**
 *     A single cell on a cell field. A projected cell is the one that participates
 * in intermediate user choice.
 * @extends {ru.hulkmoto.CellController} ‎
 * @implements {ru.hulkmoto.ICellController} ‎
 */
export class AbstractCellController extends _AbstractCellController {

}
initAbstract(_AbstractCellController, 'ICellController', /** @this {AbstractCellController} */ function () {
 const { superStateful: { setState, initialState } } = this
 const state = {
  start: false,
  occupy: false,
  end: false,
  past: false,
  hidden: false,
  projectStart: false,
  projectEnd: false,
  project: false,
  ...initialState,
 }
 proxifyState(state)
 setState(state)
 const classesInfo = /** @type {!ru.hulkmoto.ICellController.Classes} */ ({
  /** @this {ru.hulkmoto.ICellController} */
  get CellSelected() {
   return this.state.start || this.state.end
  },
  /** @this {ru.hulkmoto.ICellController} */
  get CellProjected() {
   return this.state.project
  },
  /** @this {ru.hulkmoto.ICellController} */
  get CellOccupied() {
   return this.state.occupy
  },
  /** @this {ru.hulkmoto.ICellController} */
  get CellProjectEnd() {
   return this.state.projectEnd
  },
  /** @this {ru.hulkmoto.ICellController} */
  get CellProjectStart() {
   return this.state.projectStart
  },
  /** @this {ru.hulkmoto.ICellController} */
  get CellPast() {
   return this.state.past
  },
 })
 setupClassSeersDelayed(this, classesInfo, this)
})
/** @constructor @extends {_AbstractCellController} @suppress {checkTypes} */ function __AbstractCellController() {}
__AbstractCellController.prototype = /** @type {!_AbstractCellController} */ ({
 get asICellController() {
  return /** @type {!ru.hulkmoto.BoundICellController} */ (this)
 },
 get superICellController() {
  return /** @type {!ru.hulkmoto.BoundICellController} */ (bindPrototype(_AbstractCellController, this))
 },
 get superCellController() {
  return /** @type {!ru.hulkmoto.BoundCellController} */ (bindPrototype(_AbstractCellController, this))
 },
})
export const CellControllerSymbols = {
 __: makeClassSymbol(AbstractCellController, '__'),
}

/** @type {ru.hulkmoto.getCellControllerSymbols} */
export const getCellControllerSymbols = (instance) => {
 return /** @type {!ru.hulkmoto.ICellControllerSymbolsOut} */ (getSymbols(instance, CellControllerSymbols))
}
/** @type {ru.hulkmoto.setCellControllerSymbols} */
export const setCellControllerSymbols = (instance, symbols) => {
 setSymbols(instance, symbols, CellControllerSymbols)
}

AbstractCellController.__implement(__AbstractCellController, BuildingBlock)

/**
 * @abstract
 * @extends {ru.hulkmoto.DateRange}
 */
class _AbstractDateRange {
 constructor() {
  construct(this)
 }
}
/**
 * Represents a date range.
 * @extends {ru.hulkmoto.DateRange} ‎
 * @implements {ru.hulkmoto.IDateRange} ‎
 */
export class AbstractDateRange extends _AbstractDateRange {

}
initAbstract(_AbstractDateRange, 'IDateRange', /** @this {AbstractDateRange} */ function () {
 const { superStateful: { setState, initialState } } = this
 const state = {
  startYear: null,
  startMonth: null,
  startDate: null,
  startHours: null,
  endYear: null,
  endMonth: null,
  endDate: null,
  endHours: null,
  range: 0,
  ...initialState,
 }
 proxifyState(state)
 delegateState(state, this)
 setState(state)
})
/** @constructor @extends {_AbstractDateRange} @suppress {checkTypes} */ function __AbstractDateRange() {}
__AbstractDateRange.prototype = /** @type {!_AbstractDateRange} */ ({
 get asIDateRange() {
  return /** @type {!ru.hulkmoto.BoundIDateRange} */ (this)
 },
 get superIDateRange() {
  return /** @type {!ru.hulkmoto.BoundIDateRange} */ (bindPrototype(_AbstractDateRange, this))
 },
 get superDateRange() {
  return /** @type {!ru.hulkmoto.BoundDateRange} */ (bindPrototype(_AbstractDateRange, this))
 },
})
export const DateRangeSymbols = {
 __: makeClassSymbol(AbstractDateRange, '__'),
}

/** @type {ru.hulkmoto.getDateRangeSymbols} */
export const getDateRangeSymbols = (instance) => {
 return /** @type {!ru.hulkmoto.IDateRangeSymbolsOut} */ (getSymbols(instance, DateRangeSymbols))
}
/** @type {ru.hulkmoto.setDateRangeSymbols} */
export const setDateRangeSymbols = (instance, symbols) => {
 setSymbols(instance, symbols, DateRangeSymbols)
}

/** @constructor @extends {ru.hulkmoto.DateRanger} @suppress {checkTypes} */ function AbstractDateRanger() {}
AbstractDateRanger.prototype = /** @type {!ru.hulkmoto.DateRanger} */ ({
 /** @return {void} */
 __$constructor() {
  const { _dateRange } = getDateRangerSymbols(this)
  setDateRangerSymbols(this, {
   _dateRange: iu(_dateRange, null),
  })
 },
 get dateRange() {
  return this[DateRangerSymbols._dateRange]
 },
 get asIDateRanger() {
  return /** @type {!ru.hulkmoto.BoundIDateRanger} */ (this)
 },
 get superIDateRanger() {
  return /** @type {!ru.hulkmoto.BoundIDateRanger} */ (bindPrototype(AbstractDateRanger, this))
 },
 get superDateRanger() {
  return /** @type {!ru.hulkmoto.BoundDateRanger} */ (bindPrototype(AbstractDateRanger, this))
 },
})
export const DateRangerSymbols = {
 _dateRange: makeClassSymbol(AbstractDateRanger, '_dateRange'),
}

/** @type {ru.hulkmoto.getDateRangerSymbols} */
export const getDateRangerSymbols = (instance) => {
 return /** @type {!ru.hulkmoto.IDateRangerSymbolsOut} */ (getSymbols(instance, DateRangerSymbols))
}
/** @type {ru.hulkmoto.setDateRangerSymbols} */
export const setDateRangerSymbols = (instance, symbols) => {
 setSymbols(instance, symbols, DateRangerSymbols)
}

export { AbstractDateRanger }
AbstractDateRange.__implement(__AbstractDateRange, AbstractDateRanger, BuildingBlock)

/**
 * @abstract
 * @extends {ru.hulkmoto.CellField}
 */
class _AbstractCellField {
 constructor() {
  construct(this)
 }
}
/**
 * Represents a field with cells. An abstraction for easier control of the
 * cells by their label on the field.
 * @extends {ru.hulkmoto.CellField} ‎
 * @implements {ru.hulkmoto.ICellField} ‎
 * @implements {engineering.type.IInitialiser<ru.hulkmoto.ICellField, ru.hulkmoto.ICellField.Initialese>} ‎
 */
export class AbstractCellField extends _AbstractCellField {

}
initAbstract(_AbstractCellField, 'ICellField', /** @this {AbstractCellField} */ function () {
 const { _cellsMap, _cells } = getCellFieldSymbols(this)
 setCellFieldSymbols(this, {
  _cellsMap: iu(_cellsMap, {}),
  _cells: iu(_cells, []),
 })
})
/** @constructor @extends {_AbstractCellField} @suppress {checkTypes} */ function __AbstractCellField() {}
__AbstractCellField.prototype = /** @type {!_AbstractCellField} */ ({
 get cellsMap() {
  return this[CellFieldSymbols._cellsMap]
 },
 get cells() {
  return this[CellFieldSymbols._cells]
 },
 get asICellField() {
  return /** @type {!ru.hulkmoto.BoundICellField} */ (this)
 },
 get superICellField() {
  return /** @type {!ru.hulkmoto.BoundICellField} */ (bindPrototype(_AbstractCellField, this))
 },
 get superCellField() {
  return /** @type {!ru.hulkmoto.BoundCellField} */ (bindPrototype(_AbstractCellField, this))
 },
})
export const CellFieldSymbols = {
 _cellsMap: makeClassSymbol(AbstractCellField, '_cellsMap'),
 _cells: makeClassSymbol(AbstractCellField, '_cells'),
}

/** @type {ru.hulkmoto.getCellFieldSymbols} */
export const getCellFieldSymbols = (instance) => {
 return /** @type {!ru.hulkmoto.ICellFieldSymbolsOut} */ (getSymbols(instance, CellFieldSymbols))
}
/** @type {ru.hulkmoto.setCellFieldSymbols} */
export const setCellFieldSymbols = (instance, symbols) => {
 setSymbols(instance, symbols, CellFieldSymbols)
}

AbstractCellField.__implement(__AbstractCellField)
/**
 * @abstract
 * @extends {ru.hulkmoto.CellFieldController}
 */
class _AbstractCellFieldController {
 constructor() {
  construct(this)
 }
 /** @nocollapse */
 static control(el, opts) {
  const AllSymbols = CellFieldControllerSymbols
  /** @suppress {checkTypes} */
  const res = control(this, el, opts, AllSymbols)
  return /** @type {!ru.hulkmoto.CellFieldController} */ (res)
 }
}
/**
 * A 2D field with cells that can be selected via user interactions.
 * @extends {ru.hulkmoto.CellFieldController} ‎
 * @implements {ru.hulkmoto.ICellFieldController} ‎
 * @implements {engineering.type.IInitialiser<ru.hulkmoto.ICellFieldController, ru.hulkmoto.ICellFieldController.Initialese>} ‎
 */
export class AbstractCellFieldController extends _AbstractCellFieldController {

}
initAbstract(_AbstractCellFieldController, 'ICellFieldController', /** @this {AbstractCellFieldController} */ function () {
 const { _cellField, _projected } = getCellFieldControllerSymbols(this)
 setCellFieldControllerSymbols(this, {
  _cellField: iu(_cellField, null),
 })
 const { superStateful: { setState, initialState } } = this
 const state = {
  start: null,
  end: null,
  projectStart: null,
  projectEnd: null,
  canSelectRange: false,
  uiState: 'selectingStart',
  ...initialState,
 }
 proxifyState(state)
 delegateState(state, this)
 setState(state)
})
/** @constructor @extends {_AbstractCellFieldController} @suppress {checkTypes} */ function __AbstractCellFieldController() {}
__AbstractCellFieldController.prototype = /** @type {!_AbstractCellFieldController} */ ({
 get cellField() {
  return this[CellFieldControllerSymbols._cellField]
 },
 get projected() {
  return this[CellFieldControllerSymbols._projected]
 },
 get asICellFieldController() {
  return /** @type {!ru.hulkmoto.BoundICellFieldController} */ (this)
 },
 get superICellFieldController() {
  return /** @type {!ru.hulkmoto.BoundICellFieldController} */ (bindPrototype(_AbstractCellFieldController, this))
 },
 get superCellFieldController() {
  return /** @type {!ru.hulkmoto.BoundCellFieldController} */ (bindPrototype(_AbstractCellFieldController, this))
 },
})
export const CellFieldControllerSymbols = {
 _cellField: makeClassSymbol(AbstractCellFieldController, '_cellField'),
 _projected: makeClassSymbol(AbstractCellFieldController, '_projected'),
}

/** @type {ru.hulkmoto.getCellFieldControllerSymbols} */
export const getCellFieldControllerSymbols = (instance) => {
 return /** @type {!ru.hulkmoto.ICellFieldControllerSymbolsOut} */ (getSymbols(instance, CellFieldControllerSymbols))
}
/** @type {ru.hulkmoto.setCellFieldControllerSymbols} */
export const setCellFieldControllerSymbols = (instance, symbols) => {
 setSymbols(instance, symbols, CellFieldControllerSymbols)
}

AbstractCellFieldController.__implement(__AbstractCellFieldController, BuildingBlock)
/**
 * @abstract
 * @extends {ru.hulkmoto.OccupiableCellFieldController}
 */
class _AbstractOccupiableCellFieldController {
 constructor() {
  construct(this)
 }
}
/**
 * A field where cells can be occupied.
 * @extends {ru.hulkmoto.OccupiableCellFieldController} ‎
 * @implements {ru.hulkmoto.IOccupiableCellFieldController} ‎
 */
export class AbstractOccupiableCellFieldController extends _AbstractOccupiableCellFieldController {

}
initAbstract(_AbstractOccupiableCellFieldController, 'IOccupiableCellFieldController')
/** @constructor @extends {_AbstractOccupiableCellFieldController} @suppress {checkTypes} */ function __AbstractOccupiableCellFieldController() {}
__AbstractOccupiableCellFieldController.prototype = /** @type {!_AbstractOccupiableCellFieldController} */ ({
 get occupied() {
  return this[OccupiableCellFieldControllerSymbols._occupied]
 },
 get asIOccupiableCellFieldController() {
  return /** @type {!ru.hulkmoto.BoundIOccupiableCellFieldController} */ (this)
 },
 get superIOccupiableCellFieldController() {
  return /** @type {!ru.hulkmoto.BoundIOccupiableCellFieldController} */ (bindPrototype(_AbstractOccupiableCellFieldController, this))
 },
 get superOccupiableCellFieldController() {
  return /** @type {!ru.hulkmoto.BoundOccupiableCellFieldController} */ (bindPrototype(_AbstractOccupiableCellFieldController, this))
 },
})
export const OccupiableCellFieldControllerSymbols = {
 _occupied: makeClassSymbol(AbstractOccupiableCellFieldController, '_occupied'),
}

/** @type {ru.hulkmoto.getOccupiableCellFieldControllerSymbols} */
export const getOccupiableCellFieldControllerSymbols = (instance) => {
 return /** @type {!ru.hulkmoto.IOccupiableCellFieldControllerSymbolsOut} */ (getSymbols(instance, OccupiableCellFieldControllerSymbols))
}
/** @type {ru.hulkmoto.setOccupiableCellFieldControllerSymbols} */
export const setOccupiableCellFieldControllerSymbols = (instance, symbols) => {
 setSymbols(instance, symbols, OccupiableCellFieldControllerSymbols)
}

AbstractOccupiableCellFieldController.__implement(__AbstractOccupiableCellFieldController)

/**
 * @abstract
 * @extends {ru.hulkmoto.AvailabilityLoader}
 */
class _AbstractAvailabilityLoader {
 constructor() {
  construct(this)
 }
}
/**
 * The bike loader to display info about prices.
 * @extends {ru.hulkmoto.AvailabilityLoader} ‎
 * @implements {ru.hulkmoto.IAvailabilityLoader} ‎
 */
export class AbstractAvailabilityLoader extends _AbstractAvailabilityLoader {

}
initAbstract(_AbstractAvailabilityLoader, 'IAvailabilityLoader', /** @this {AbstractAvailabilityLoader} */ function () {
 const { superStateful: { setState, initialState } } = this
 const state = {
  availability: [],
  ...initialState,
 }
 proxifyState(state)
 setState(state)
})
/** @constructor @extends {_AbstractAvailabilityLoader} @suppress {checkTypes} */ function __AbstractAvailabilityLoader() {}
__AbstractAvailabilityLoader.prototype = /** @type {!_AbstractAvailabilityLoader} */ ({
 get asIAvailabilityLoader() {
  return /** @type {!ru.hulkmoto.BoundIAvailabilityLoader} */ (this)
 },
 get superIAvailabilityLoader() {
  return /** @type {!ru.hulkmoto.BoundIAvailabilityLoader} */ (bindPrototype(_AbstractAvailabilityLoader, this))
 },
 get superAvailabilityLoader() {
  return /** @type {!ru.hulkmoto.BoundAvailabilityLoader} */ (bindPrototype(_AbstractAvailabilityLoader, this))
 },
})
AbstractAvailabilityLoader.__implement(__AbstractAvailabilityLoader, BuildingBlock)

/**
 * @abstract
 * @extends {ru.hulkmoto.BookingLoader}
 */
class _AbstractBookingLoader {
 constructor() {
  construct(this)
 }
}
/**
 * The bike loader to display info about prices.
 * @extends {ru.hulkmoto.BookingLoader} ‎
 * @implements {ru.hulkmoto.IBookingLoader} ‎
 */
export class AbstractBookingLoader extends _AbstractBookingLoader {

}
initAbstract(_AbstractBookingLoader, 'IBookingLoader', /** @this {AbstractBookingLoader} */ function () {
 const { superStateful: { setState, initialState } } = this
 const state = {
  booking: null,
  ...initialState,
 }
 proxifyState(state)
 setState(state)
})
/** @constructor @extends {_AbstractBookingLoader} @suppress {checkTypes} */ function __AbstractBookingLoader() {}
__AbstractBookingLoader.prototype = /** @type {!_AbstractBookingLoader} */ ({
 get asIBookingLoader() {
  return /** @type {!ru.hulkmoto.BoundIBookingLoader} */ (this)
 },
 get superIBookingLoader() {
  return /** @type {!ru.hulkmoto.BoundIBookingLoader} */ (bindPrototype(_AbstractBookingLoader, this))
 },
 get superBookingLoader() {
  return /** @type {!ru.hulkmoto.BoundBookingLoader} */ (bindPrototype(_AbstractBookingLoader, this))
 },
})
AbstractBookingLoader.__implement(__AbstractBookingLoader, BuildingBlock)

/**
 * @abstract
 * @extends {ru.hulkmoto.PlannerController}
 */
class _AbstractPlannerController {
 constructor() {
  construct(this)
 }
 /** @nocollapse */
 static control(el, opts) {
  const AllSymbols = { ...PlannerControllerSymbols, ...DateRangerSymbols }
  /** @suppress {checkTypes} */
  const res = control(this, el, opts, AllSymbols)
  return /** @type {!ru.hulkmoto.PlannerController} */ (res)
 }
}
/**
 * An hourly planner.
 * @extends {ru.hulkmoto.PlannerController} ‎
 * @implements {ru.hulkmoto.IPlannerController} ‎
 * @implements {engineering.type.IInitialiser<ru.hulkmoto.IPlannerController, ru.hulkmoto.IPlannerController.Initialese>} ‎
 */
export class AbstractPlannerController extends _AbstractPlannerController {

}
initAbstract(_AbstractPlannerController, 'IPlannerController', /** @this {AbstractPlannerController} */ function () {
 const { __, _availabilityLoader } = getPlannerControllerSymbols(this)
 setPlannerControllerSymbols(this, {
  _availabilityLoader: iu(_availabilityLoader, null),
 })
 const { superProper: { setProps, initialProps } } = this
 const props = {
  title: '',
  ...initialProps,
 }
 proxifyState(props)
 setProps(props)
})
/** @constructor @extends {_AbstractPlannerController} @suppress {checkTypes} */ function __AbstractPlannerController() {}
__AbstractPlannerController.prototype = /** @type {!_AbstractPlannerController} */ ({
 get availabilityLoader() {
  return this[PlannerControllerSymbols._availabilityLoader]
 },
 get asIPlannerController() {
  return /** @type {!ru.hulkmoto.BoundIPlannerController} */ (this)
 },
 get superIPlannerController() {
  return /** @type {!ru.hulkmoto.BoundIPlannerController} */ (bindPrototype(_AbstractPlannerController, this))
 },
 get superPlannerController() {
  return /** @type {!ru.hulkmoto.BoundPlannerController} */ (bindPrototype(_AbstractPlannerController, this))
 },
})
export const PlannerControllerSymbols = {
 __: makeClassSymbol(AbstractPlannerController, '__'),
 _availabilityLoader: makeClassSymbol(AbstractPlannerController, '_availabilityLoader'),
}

/** @type {ru.hulkmoto.getPlannerControllerSymbols} */
export const getPlannerControllerSymbols = (instance) => {
 return /** @type {!ru.hulkmoto.IPlannerControllerSymbolsOut} */ (getSymbols(instance, PlannerControllerSymbols))
}
/** @type {ru.hulkmoto.setPlannerControllerSymbols} */
export const setPlannerControllerSymbols = (instance, symbols) => {
 setSymbols(instance, symbols, PlannerControllerSymbols)
}

/** @constructor @extends {ru.hulkmoto.PlannerController} @suppress {checkTypes} */ function PlannerControllerChildren() {}
PlannerControllerChildren.prototype = /** @type {!ru.hulkmoto.PlannerController} */ ({
 /** @return {void} */
 __$constructor() {
  const children = getDataIds(this)
  setPlannerControllerChildrenSymbols(this, {
   _PlannerHeading: /** @type {HTMLHeadingElement} */ (children['PlannerHeading']),
   _PlannerBody: /** @type {HTMLTableSectionElement} */ (children['PlannerBody']),
  })
 },
 get PlannerHeading() {
  return this[PlannerControllerChildrenSymbols._PlannerHeading]
 },
 get PlannerBody() {
  return this[PlannerControllerChildrenSymbols._PlannerBody]
 },
})
export const PlannerControllerChildrenSymbols = {
 _PlannerHeading: makeClassSymbol(PlannerControllerChildren, '_PlannerHeading'),
 _PlannerBody: makeClassSymbol(PlannerControllerChildren, '_PlannerBody'),
}

/** @type {ru.hulkmoto.getPlannerControllerChildrenSymbols} */
export const getPlannerControllerChildrenSymbols = (instance) => {
 return /** @type {!ru.hulkmoto.IPlannerControllerChildrenSymbolsOut} */ (getSymbols(instance, PlannerControllerChildrenSymbols))
}
/** @type {ru.hulkmoto.setPlannerControllerChildrenSymbols} */
export const setPlannerControllerChildrenSymbols = (instance, symbols) => {
 setSymbols(instance, symbols, PlannerControllerChildrenSymbols)
}

AbstractPlannerController.__implement(__AbstractPlannerController, PlannerControllerChildren, BuildingBlock)

// /** @abstract {ru.hulkmoto.ILoginService} */
// export class AbstractLoginService {}


const popupCenter = ({url, title, w, h}) => {
 // Fixes dual-screen position                             Most browsers      Firefox
 const dualScreenLeft = window.screenLeft !==  undefined ? window.screenLeft : window.screenX;
 const dualScreenTop = window.screenTop !==  undefined   ? window.screenTop  : window.screenY;

 const width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
 const height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

 const systemZoom = width / window.screen.availWidth;
 const left = (width - w) / 2 / systemZoom + dualScreenLeft
 const top = (height - h) / 2 / systemZoom + dualScreenTop
 const newWindow = window.open(url, title,
   `
   scrollbars=yes,
   width=${w / systemZoom},
   height=${h / systemZoom},
   top=${top},
   left=${left}
   `
 )

 if (window.focus) newWindow.focus();
}